module.exports = __webpack_public_path__ + "img/manosque_grey.23114483.jpeg";